import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ContactsFilter} from '../../models/contacts/contacts.filter';

import {optimizeFilter} from '../../utils/filter.helper';
import {environment} from '../../../../environments/environment';
import {PopulatedUser, User} from '../../models/users/users.model';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactsService {
  private contactsUrl = environment.baseURL + environment.contacts;

  constructor(private http: HttpClient) {
  }

  getAll<K extends keyof User>(query: ContactsFilter & {populate: (K | `${K}:${string}`)[]}): Observable<{ docs: PopulatedUser<K>[], total: number }> {
    return this.http.get<{ docs: PopulatedUser<K>[], total: number }>(this.contactsUrl, {params: optimizeFilter(query)});
  }

  exportContacts(params: any): Observable<HttpResponse<ArrayBuffer>> {
    return this.http.get(`${this.contactsUrl}/export`, {
      headers: new HttpHeaders({
        charset: 'UTF-8',
      }),
      params,
      observe: 'response',
      responseType: 'arraybuffer'
    })
  }
}
